import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Dropdown, Tab, Nav, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  get_Single_Festival,
  get_Festival,
} from "../../../store/actions/CommanAction";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import { customStyles, editorConfig } from "../Utility/Utility";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import { ClassicEditor } from "ckeditor5";
import Loader from "../Loader/Loader";

const Festival = () => {
  const dispatch = useDispatch();
  const customerID = Number(sessionStorage.getItem("ID"));
  const FestivalsData = useSelector(
    (state) => state.feedBackReducer.GetFestivals
  );
 
  
  const FestivalSingleData = useSelector(
    (state) => state.feedBackReducer.GetSingleFestival
  );

  const FestivalDrpData = [
    { label: "Festival 2025", value: "2025" },
    { label: "Festival 2026", value: "2026" },
    { label: "Festival 2027", value: "2027" },
    { label: "Festival 2028", value: "2028" },
    { label: "Festival 2029", value: "2029" },
    { label: "Festival 2030", value: "2030" },
  ];

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  

  const [EditValue, setEditValue] = useState();
  const [FestivalID, setID] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [loading, setloading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    FestivalYear: "",
    FestivalMonth:"",
    Description: "",
    CreatedByUser: customerID,
    DescriptionDoc: "",
  });

  useEffect(() => {
    if (IsActive) {
      dispatch(get_Festival("1", setloading));
    } else {
      dispatch(get_Festival("0", setloading));
    }
  }, [IsActive, IsActive]);
  
 

  

  const Reset = () => {
    setaddFormData({
      ...addFormData,
      FestivalYear: "",
      FestivalMonth:"",
      Description: "",
      DescriptionDoc: "",
    });
    setEditorState(() => EditorState.createEmpty());
  };

  const ChangeDropDown = (e, name) => {
    setaddFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: e ? e.value : null,
      };

      return updatedData;
    });
  };

  const handleAddFormSubmit = async (e) => {
    let error = false;
    let errorMsg = "";
    if (addFormData.FestivalYear === "") {
      error = true;
      errorMsg = "Please fill Festival Year.";
    }
    if(addFormData.Description===""){
      error=true;
      errorMsg="please fill festival Description"   
    }
    const existingCategory = Array.isArray(FestivalsData)
      ? FestivalsData.map((h) => h.FestivalYear)
      : [];
    if (existingCategory.includes(addFormData.FestivalYear)) {
      error = true;
      errorMsg = " This Festival year is already exists.";
    }
    if (error) {
      swal("Validation Error", errorMsg, "warning");
      return;
    }
    if (!error) {
      const formDataToSave = {
        ...addFormData,
        FestivalYear: addFormData.FestivalYear,
        Description: addFormData.Description,
      };
      
      await AddUpdate("Festival/Insert_Festival", formDataToSave);
      swal("Good job!", "Successfully insert", "success");
      dispatch(get_Festival("1", setloading));
      setPostModal(false);
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const UpdateCategory = async (e) => {
    e.preventDefault();
    let error = false;
    let errorMsg = "";
    if (addFormData.Description === "") {
      error = true;
      errorMsg = "Please fill Festival Description.";
    }
    if (error) {
      swal("Validation Error", errorMsg, "warning");
      return;
    }
    if (!error) {
      const UpdateData = {
        Description: addFormData.Description,
        DescriptionDoc: addFormData.DescriptionDoc,
        ModifiedByUser: customerID,
        FestivalYear: addFormData.FestivalYear,
        FestivalID: FestivalID,
      };
     

      await AddUpdate("Festival/Update_Festival", UpdateData);
      swal("Good job!", "Successfully Updated", "success");
      dispatch(get_Festival("1", setloading));
      setEditModal(false);
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  useEffect(() => {
    if (FestivalSingleData) {
      setEditValue(FestivalSingleData);
    }
  }, [FestivalSingleData]);

  useEffect(() => {
    setID(FestivalID);

    dispatch(get_Single_Festival(FestivalID));
  }, [FestivalID]);

  const handleEditClick = (row) => {
    setID(row?.FestivalID);
    setEditModal(true);
  };

  useEffect(() => {
         
    if (EditValue && EditValue.length > 0) {

      setaddFormData((prev) => ({
        ...prev,
        FestivalYear: EditValue[0]?.FestivalYear || "",
        Description: EditValue[0]?.Description || "",
        DescriptionDoc: EditValue[0]?.DescriptionDoc || "",
      }));
    }
  }, [EditValue]);
  

  const handleToggleStatusClick = async (
    FestivalID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      FestivalID: FestivalID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
  
    await AddUpdate("Festival/Delete_Festival", postData);
    dispatch(get_Festival(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  const columns = [
    {
      name: "Festival  Description",
      selector: (row) => row.Description,
      sortable: true,
      format: (row) => (
        <>
          {row?.Description ? row?.Description.substring(0, 20) : ""}
          {row?.Description?.length > 20 ? "  . . ." : null}{" "}
        </>
      ),
    },
    {
      name: "Festival Year",
      selector: (row) => row.FestivalYear,
      sortable: true,
    },
    // <td>
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 50 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item onClick={() => handleEditClick(row)}>
                  Edit
                </Dropdown.Item>
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.FestivalID, true, "0");
                  }}
                >
                  Inactive
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
    // </td>
  ];
  const columns1 = [
    {
      name: "Festival Description",
      selector: (row) => row.Description,
      sortable: true,
      format: (row) => (
        <>
          {row?.Description ? row?.Description.substring(0, 20) : ""}
          {row?.Description?.length > 20 ? "  . . ." : null}{" "}
        </>
      ),
    },
    {
      name: "Festival Year",
      selector: (row) => row.FestivalYear,
      sortable: true,
    },

    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.FestivalID, false, "1"); 
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap main_card">
          <div className="card-action coin-tabs ">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="All"
                  onClick={(currentStatus) => {
                    setIsActive(true);
                  }}
                >
                  Active
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="nav-item">
                <Nav.Link
                  className="nav-link"
                  eventKey="Inactive"
                  onClick={(currentStatus) => {
                    setIsActive(false);
                  }}
                >
                  Inactive
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Link
            to={"#"}
            className="btn btn-primary font-w600 "
            onClick={() => {
              setPostModal(true);
              Reset();
            }}
          >
            + New Festival
          </Link>
        </div>
        <div className="row main_card">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-5 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade "
                        size="xl"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">Add Festival</h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label className="form-label">
                                    Festival Year
                                  </label>
                                 

                                  <Select
                                    name="FestivalYear"
                                    options={FestivalDrpData}
                                    onChange={(e) =>
                                      ChangeDropDown(
                                        e,
                                        "FestivalYear",
                                        "HoroscopeName"
                                      )
                                    }
                                    placeholder="Select Status.."
                                    isClearable={true}
                                    required
                                  />
                                </div>

                                <div className="form-group mt-4">
                                  <label className="form-label">
                                    Long Festival
                                  </label>

                                  <CKEditor
                                    editor={ClassicEditor}
                                    config={editorConfig}
                                    data={addFormData.DescriptionDoc}
                                    onReady={(editor) => {
                                      
                                    }}
                                    onChange={(event, editor) => {
                                      const htmlContent = editor.getData();

                                      const plainText = htmlContent
                                        .replace(/<[^>]+>/g, "")
                                        .replace(/&nbsp;/g, " ")
                                        .replace(/\s+/g, " ")
                                        .trim();

                                      setaddFormData((prevState) => ({
                                        ...prevState,
                                        DescriptionDoc: htmlContent,
                                        Description: plainText,
                                      }));
                                    }}
                                    onBlur={(event, editor) => {
                                      
                                    }}
                                    onFocus={(event, editor) => {
                                   
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      size="xl"
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit Festival
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <label className="form-label">
                                    Festival Year
                                  </label>
                                  <Select
                                    name="FestivalYear"
                                    options={FestivalDrpData}
                                    onChange={(e) =>
                                      ChangeDropDown(
                                        e,
                                        "FestivalYear",
                                        "HoroscopeName"
                                      )
                                    }
                                    placeholder="Select Status.."
                                    isClearable={true}
                                    isDisabled={true}
                                    required
                                  />
                                 
                                </div>

                                <div className="form-group mt-4 ">
                                  <label className="form-label">
                                    Long Festival
                                  </label>
                                  <CKEditor
                                    editor={ClassicEditor}
                                    config={editorConfig}
                                    data={addFormData.DescriptionDoc || []}
                                    onReady={(editor) => {
                                    
                                    }}
                                    onChange={(event, editor) => {
                                      const htmlContent = editor.getData();

                                      const plainText = htmlContent
                                        .replace(/<[^>]+>/g, "")
                                        .replace(/&nbsp;/g, " ")
                                        .replace(/\s+/g, " ")
                                        .trim();

                                      setaddFormData((prevState) => ({
                                        ...prevState,
                                        DescriptionDoc: htmlContent,
                                        Description: plainText,
                                      }));
                                    }}
                                    onBlur={(event, editor) => {
                                  
                                    }}
                                    onFocus={(event, editor) => {
                                    
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateCategory}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={FestivalsData}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          onRowClicked={(row) => {
                          }}
                          fixedHeader
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={FestivalsData}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            onRowClicked={(row) => {
                            }}
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                            customStyles={customStyles}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};

export default Festival;
